import { Styled } from './';

const LoadingBar = () => {
  return (
    <Styled.LoaderContainer>
      <Styled.LinearActivity>
        <Styled.Indeterminate></Styled.Indeterminate>
      </Styled.LinearActivity>
    </Styled.LoaderContainer>
  );
};

export default LoadingBar;
